import './LoadingScreen.css';

export default function LoadingScreen({ message = 'Loading AceIt AI...' }) {
  return <div className="ace-loading-screen" role="status" aria-live="polite" aria-busy="true">
    <div className="ace-loading-scene" aria-hidden="true">
      <div className="ace-loading-halo ace-loading-halo-one" />
      <div className="ace-loading-halo ace-loading-halo-two" />
      <div className="ace-loading-halo ace-loading-halo-three" />
      <div className="ace-loading-core">
        <span className="ace-loading-core-face ace-loading-core-front" />
        <span className="ace-loading-core-face ace-loading-core-back" />
        <span className="ace-loading-core-face ace-loading-core-right" />
        <span className="ace-loading-core-face ace-loading-core-left" />
        <span className="ace-loading-core-face ace-loading-core-top" />
        <span className="ace-loading-core-face ace-loading-core-bottom" />
      </div>
      <span className="ace-loading-spark ace-loading-spark-one" />
      <span className="ace-loading-spark ace-loading-spark-two" />
      <span className="ace-loading-spark ace-loading-spark-three" />
    </div>
    <div className="ace-loading-copy"><strong>ACEIT <span>AI</span></strong><p>{message}</p><div className="ace-loading-progress" aria-hidden="true"><span /></div></div>
  </div>;
}